export default function ({ $auth, redirect }) {
    let user = $auth.user
    const allowed = ["admin@oabat.de", "dashboard@oabat.de"]
    if (!user || !allowed.includes(user.email)) {
        redirect({ name: "index" })
    }
}
